<template>
    <div class="productGroup">
        <main class="content">
            <!--搜索区-->
            <el-card>
                <el-form :inline="true" :model="searchForm" size="mini">
                    <el-form-item label="专区名称">
                        <el-input v-model="searchForm.name" placeholder="请输入专区名称" size="mini" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="() => {this.currentPage=1;onSearch();}" size="mini">查询</el-button>
                    </el-form-item>
                </el-form>
                <!--数据展示区-->
                <el-table stripe :data="tableData" v-loading="loading" style="width: 100%" :max-height="tableHeight" size="mini">
                    <el-table-column prop="name" label="专区名称" min-width="200"/>
                    <el-table-column label="操作" width="250" align="right" fixed="right">
                        <template slot="header">
                            <el-button type="primary" @click="handleCreateGroup" size="mini">添加</el-button>
                        </template>
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" @click="preview(scope.$index, scope.row)">详情</el-button>
                            <el-divider direction="vertical" ></el-divider>
                            <el-button type="text" size="mini" @click="handleDelete(scope.$index, scope.row)" style="color: red">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="text-align: center;padding-top: 20px">
                    <el-pagination
                        background
                        layout="sizes,prev, pager, next"
                        :page-sizes="[10, 20, 50, 100]"
                        v-if="total>0"
                        :total="total"
                        :page-size="pageSize"
                        @size-change="handleSizeChange"
                        @current-change="onPageChange"
                        :current-page="currentPage"
                        @prev-click="onPageChange"
                        @next-click="onPageChange">
                    </el-pagination>
                </div>
            </el-card>
        </main>
        <el-dialog title="新建专区" :modal="true" :visible.sync="editDialogVisible" width="400px">
            <el-form ref="editForm" :model="editForm" :rules="rules" label-width="100px">
                <el-form-item label="专区名称" prop="name">
                    <el-input v-model="editForm.name" placeholder="请输入专区名称" clearable></el-input>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                searchForm: {
                    name: "",
                },
                editForm: {
                    name: "",
                },
                loading: false,
                total: 0,
                pageSize: 10,
                currentPage: 1,
                tableData: [],
                editDialogVisible: false,
            }
        },
        computed: {
            tableHeight() {
                return this.$store.state.clientHeight - 320;
            }
        },
        methods: {
            onSearch() {
                let params = {};
                if (this.searchForm.name != "") {
                    params["name"] = this.searchForm.name;
                }
                if (this.searchForm.status != "") {
                    params["status"] = this.searchForm.status;
                }

                this.loading = true;

                let _this = this
                this.$axios.post("/admin/product/group/search", {
                    cond: params,
                    page: this.currentPage - 1,size:this.pageSize
                }).then(function (response) {
                    let resp = response.data;
                    if (resp.header.status == 0) {
                        _this.loading = false;
                        _this.tableData = resp.data.content;
                        _this.total = resp.data.totalElements;
                    }
                }).catch(function () {
                });
            },
            handleSizeChange(pageSize){
                this.pageSize = pageSize;
                this.onSearch();
            },
            onPageChange(currentPage) {
                this.currentPage = currentPage;
                this.onSearch();
            },
            handleCreateGroup() {
                this.editDialogVisible = true;

            },
            handleDelete(index, row) {
                this.$confirm(`是否确认删除【${row['name']}】?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$axios.get(`/admin/product/group/delete/${row.id}`,
                    ).then(function (response) {
                        let resp = response.data;
                        if (resp.header.status === 0) {
                            this.$notify({
                                title: '成功',
                                message: '数据已删除',
                                type: 'success'
                            });
                            this.onSearch();
                        } else {
                            this.$notify.error({
                                title: '错误',
                                message: resp.header.msg
                            });
                        }
                    }).catch(function () {
                    });
                });
            },
            handleUpload() {
                this.uploadDialogVisible = true;
            },
            uploadSuccess(response) {
                const {header: {status, msg}} = response;
                this.$refs.upload.clearFiles();
                if(status === 0) {
                    this.$notify({
                        title: '成功',
                        message: '数据保存成功',
                        type: 'success'
                    });
                    this.uploadDialogVisible = false;
                    this.onSearch();
                } else {
                    this.uploadCheckResult = msg;
                }
            },
            formatterMoney(row, col, value) {
                if(value) {
                    return this.MoneyFormat(value, "", 2);
                } else {
                    return "-";
                }
            },
        },
        created() {
            this.onSearch()
        },
    }
</script>
<style>
</style>
